export const dashboardJa = {
  // shared — DashboardNav
  'dashboard.nav.ariaLabel': 'ダッシュボードセクション',
  'dashboard.nav.overview': '概要',
  'dashboard.nav.avatar': 'アバター',
  'dashboard.nav.coins': 'コイン',
  'dashboard.nav.contributions': '投稿',

  // shared — StatusBadge (contribution status)
  'dashboard.status.draft': '下書き',
  'dashboard.status.submitted': '送信済み',
  'dashboard.status.communityReview': 'コミュニティレビュー',
  'dashboard.status.officialReview': '公式レビュー',
  'dashboard.status.approved': '承認済み',
  'dashboard.status.rejected': '却下',
  'dashboard.status.unknown': '不明',

  // shared — ClaimStatusBadge
  'dashboard.claimStatus.pending': '保留中',
  'dashboard.claimStatus.approved': '承認',
  'dashboard.claimStatus.rejected': '却下',

  // DashboardPage
  'dashboard.seo.title': '私のGrymwyrd',
  'dashboard.seo.description': '永遠の黄昏の世界に、汝のコイン、請求、投稿、そしてキャラクターあり。',
  'dashboard.displayNameFallback': '放浪者',
  'dashboard.welcomeBack': 'おかえりなさい',
  'dashboard.editAvatar': 'アバターを編集',
  'dashboard.loading': '汝の物語を編纂中…',
  'dashboard.avatarAlt': '{name}の肖像',
  'dashboard.offlineNotice':
    'ライブプロフィールデータが利用不可 — 前回のセッションとサンプルコンテンツを表示しています。',

  // DashboardPage — Coins card
  'dashboard.coins.title': '墓地のコイン',
  'dashboard.coins.viewAll': 'すべて表示',
  'dashboard.coins.unit': 'コイン',
  'dashboard.coins.noActivity': 'コインの活動はまだありません。',
  'dashboard.coins.fullHistory': '全履歴とコイン購入',

  // DashboardPage — Contributions card
  'dashboard.contributions.title': '投稿',
  'dashboard.contributions.manage': '管理',
  'dashboard.contributions.empty': 'まだ投稿がありません — 最初の一編を著しましょう。',

  // DashboardPage — Claims card
  'dashboard.claims.title': 'クレーム地領',
  'dashboard.claims.empty': 'Grymwyrdの土地はまだ領有していません。',
  'dashboard.claims.kindClaimed': '{kind} · {date}に領有',

  // DashboardPage — Characters card
  'dashboard.characters.title': 'キャラクター',
  'dashboard.characters.empty': '汝の名に縛られし者なし。',
  'dashboard.characters.level': 'Lv {level}',
  'dashboard.characters.unknown': '不明',

  // AvatarEditorPage
  'dashboard.avatarEditor.seo.title': 'アバターエディター',
  'dashboard.avatarEditor.seo.description': 'Grymwyrdの世界に向けて、汝が示す顔を造形する。',
  'dashboard.avatarEditor.heading': 'アバターエディター',
  'dashboard.avatarEditor.errorNotImage': 'そのファイルは画像ではありません。',
  'dashboard.avatarEditor.errorNameRequired': '暗黒の中においても名前は必須です。',
  'dashboard.avatarEditor.portrait': '肖像',
  'dashboard.avatarEditor.portraitPreview': '肖像プレビュー',
  'dashboard.avatarEditor.avatarPreviewAlt': 'アバタープレビュー',
  'dashboard.avatarEditor.zoom': 'ズーム',
  'dashboard.avatarEditor.zoomAria': '肖像をズーム',
  'dashboard.avatarEditor.panHorizontal': '肖像を水平パン',
  'dashboard.avatarEditor.panVertical': '肖像を垂直パン',
  'dashboard.avatarEditor.uploadAria': '肖像画像をアップロード',
  'dashboard.avatarEditor.changeImage': '画像を変更',
  'dashboard.avatarEditor.uploadImage': '画像をアップロード',
  'dashboard.avatarEditor.identity': 'アイデンティティ',
  'dashboard.avatarEditor.displayName': '表示名',
  'dashboard.avatarEditor.backstory': 'バックストーリー',
  'dashboard.avatarEditor.backstoryPlaceholder': '汝はいずこより来りし者か、いかなる暗き運命を追い求めるや。',
  'dashboard.avatarEditor.publicProfile': '公開プロフィール',
  'dashboard.avatarEditor.publicVisible': '伝説の殿堂に表示されます。',
  'dashboard.avatarEditor.publicHidden': '他の放浪者から非表示。',
  'dashboard.avatarEditor.saving': '保存中…',
  'dashboard.avatarEditor.saveChanges': '変更を保存',
  'dashboard.avatarEditor.saved': '保存済み',

  // CoinHistoryPage
  'dashboard.coinHistory.checkoutUnavailable': 'チェックアウトはまだ利用できません — 金庫は閉ざされたままです。',
  'dashboard.coinHistory.notEnoughCoins': 'それには十分なコインがありません。',
  'dashboard.coinHistory.reasonWorldClaim': '土地領有',
  'dashboard.coinHistory.reasonCosmetic': 'コスメティック',
  'dashboard.coinHistory.spendReason': '{category} — {name}',
  'dashboard.coinHistory.spentNotice': '{name}に{cost}枚のコインを支出しました。',
  'dashboard.coinHistory.seo.title': '墓地のコイン',
  'dashboard.coinHistory.seo.description': '汝の完全なコイン帳簿、チャージアップ、そして死者の商品。',
  'dashboard.coinHistory.heading': '墓地のコイン',
  'dashboard.coinHistory.balance': '残高',
  'dashboard.coinHistory.buyCoins': 'コインを購入',
  'dashboard.coinHistory.packCoins': '{coins}枚のコイン',
  'dashboard.coinHistory.packBonus': ' + {bonus}ボーナス',
  'dashboard.coinHistory.summoningCheckout': 'チェックアウト召喚中…',
  'dashboard.coinHistory.purchase': '購入',
  'dashboard.coinHistory.spendCoins': 'コインを支出',
  'dashboard.coinHistory.insufficientCoins': 'コイン不足',
  'dashboard.coinHistory.spending': '支出中…',
  'dashboard.coinHistory.spendAmount': '{cost}を支出',
  'dashboard.coinHistory.historyTitle': '履歴',
  'dashboard.coinHistory.tallyingLedger': '帳簿を集計中…',
  'dashboard.coinHistory.tableCaption': 'コイン取引履歴',
  'dashboard.coinHistory.colReason': '理由',
  'dashboard.coinHistory.colAmount': '金額',
  'dashboard.coinHistory.noTransactions': 'まだトランザクションはありません。',

  // ContributionsPage
  'dashboard.contributionsPage.seo.title': '私の投稿',
  'dashboard.contributionsPage.seo.description':
    '汝が著しし物語と、主宰者らの視線の中での通過。',
  'dashboard.contributionsPage.heading': '投稿',
  'dashboard.contributionsPage.newContribution': '新規投稿',
  'dashboard.contributionsPage.loading': '汝の巻物を繙いている…',
  'dashboard.contributionsPage.empty': 'まだ物語は著されていません。最初の投稿を開始してください。',
  'dashboard.contributionsPage.untitledDraft': 'タイトルなしの下書き',
  'dashboard.contributionsPage.moderator': 'モデレーター:',
  'dashboard.contributionsPage.entryFallback': 'エントリ',
  'dashboard.contributionsPage.errorNameRequired': 'すべての創作には名前が必要です。',
  'dashboard.contributionsPage.modalTitle': '新規投稿',
  'dashboard.contributionsPage.type': 'タイプ',
  'dashboard.contributionsPage.titleLabel': 'タイトル',
  'dashboard.contributionsPage.summaryLabel': 'サマリー',
  'dashboard.contributionsPage.saveDraft': '下書きを保存',
  'dashboard.contributionsPage.submitting': '送信中…',
  'dashboard.contributionsPage.submitForReview': 'レビューに送信',
}
